import * as types from '../mutation-type'

const state = {
  isShowLoading: false,
}

const actions = {
  isShowLoading({ commit }, status) {
    commit(types.IS_SHOW_LOADING, status)
  },
}

const getters = {
  // eslint-disable-next-line no-shadow
  isShowLoading: (state) => state.isShowLoading,
}

const mutations = {
  // eslint-disable-next-line no-shadow
  [types.IS_SHOW_LOADING](state, status) {
    state.isShowLoading = status
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
